import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Button, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText, Container, useScrollTrigger } from '@mui/material';
import { FaBars, FaTimes } from 'react-icons/fa';
import profile from '../data/profile';

function Navbar({ sections }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const scrolled = useScrollTrigger({
    disableHysteresis: true,
    threshold: 60,
  });

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const visibleSections = sections.filter(s => s.visible);

  const drawer = (
    <Box sx={{ width: 280, pt: 2, height: '100%', backgroundColor: '#181614' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, mb: 3 }}>
        <IconButton onClick={handleDrawerToggle} sx={{ color: '#877D72', '&:hover': { color: '#EAE3D6' } }}>
          <FaTimes size={16} />
        </IconButton>
      </Box>
      <List sx={{ px: 1 }}>
        {visibleSections.map((section) => (
          <ListItem key={section.id} disablePadding>
            <ListItemButton
              onClick={() => scrollToSection(section.id)}
              sx={{
                borderRadius: '8px',
                px: 2,
                py: 1.25,
                mb: 0.25,
                '&:hover': { backgroundColor: 'rgba(234, 227, 214, 0.06)' },
              }}
            >
              <ListItemText
                primary={section.label}
                primaryTypographyProps={{
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  color: '#C4C0B8',
                  letterSpacing: '-0.01em',
                  fontFamily: "'DM Sans', sans-serif",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: scrolled ? 'rgba(15, 14, 13, 0.92)' : 'transparent',
          backdropFilter: scrolled ? 'blur(16px)' : 'none',
          WebkitBackdropFilter: scrolled ? 'blur(16px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(234, 227, 214, 0.07)' : 'none',
          transition: 'all 0.3s ease',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
            {/* Name / brand */}
            <Box
              onClick={scrollToTop}
              sx={{
                cursor: 'pointer',
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 600,
                fontSize: { xs: '0.9rem', md: '0.95rem' },
                color: scrolled ? '#EAE3D6' : 'rgba(234, 227, 214, 0.9)',
                letterSpacing: '-0.01em',
                transition: 'color 0.2s',
                '&:hover': { color: '#EAE3D6' },
              }}
            >
              {profile.name}
            </Box>

            <Box sx={{ flex: 1 }} />

            {/* Desktop nav */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
              {visibleSections.map((section) => (
                <Button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  sx={{
                    color: 'rgba(234, 227, 214, 0.65)',
                    fontSize: '0.82rem',
                    fontWeight: 500,
                    px: 1.5,
                    py: 0.75,
                    minWidth: 'auto',
                    '&:hover': {
                      color: '#EAE3D6',
                      backgroundColor: 'rgba(234, 227, 214, 0.06)',
                    },
                  }}
                >
                  {section.label}
                </Button>
              ))}
            </Box>

            {/* Mobile menu button */}
            <IconButton
              sx={{
                display: { xs: 'flex', md: 'none' },
                color: 'rgba(234, 227, 214, 0.7)',
                ml: 1,
                '&:hover': { color: '#EAE3D6', backgroundColor: 'rgba(234, 227, 214, 0.06)' },
              }}
              onClick={handleDrawerToggle}
            >
              <FaBars size={16} />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        PaperProps={{ sx: { backgroundColor: '#181614', backgroundImage: 'none' } }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default Navbar;
